export enum CampaignTypes {
  Form = "Form",
  JobAlerts = "JobAlerts",
  TalentNetwork = "TalentNetwork",
  JobAlertsAndTalentNetwork = "JobAlertsAndTalentNetwork",
  Event = "Event",
}

export enum CampaignContact {
  Email = "Email",
  EmailAndPhone = "Email & Phone",
  Phone = "Phone",
}

export enum CampaignPageActions {
  Create = "Create",
  Edit = "Edit",
  Duplicate = "Duplicate",
}

export enum CampaignActionIds {
  Embed = "embed",
  Edit = "edit",
  Delete = "delete",
  Duplicate = "duplicate",
  Export = "export",
}

export enum CampaignQuickActions {
  Create = "Create",
  Edit = "Edit",
  Delete = "Delete",
  Duplicate = "Duplicate",
  ViewGroup = "View Group",
  EmbedScript = "Embed Script",
  Export = "Export",
  Overwrite = "Overwrite",
}

export enum CampaignActiveStatus {
  Active = "Active",
  Scheduled = "Scheduled",
  Inactive = "Inactive",
}

export enum CampaignReportTimeframe {
  Last30Days = "Last 30 days",
  Last90Days = "Last 90 days",
  LastYear = "Last Year",
  Custom = "Custom",
}

export enum CampaignSortBy {
  Count = "Count",
  Name = "Name",
  LastUpdated = "LastUpdated",
  CreatedDate = "CreatedDate",
  LastSubmissionDate = "LastSubmissionDate",
}
